module.exports = __webpack_public_path__ + "static/img/xiazailuyin2.d6499d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/xiazailuyin2.png
// module id = 87HU
// module chunks = 24